import { createFileRoute } from '@tanstack/react-router';

import { getCompanyQueryOptions } from '@/_pages/companies/api-service';
import Loading from '@/_pages/companies/marketing-campaigns/loading';

export const Route = createFileRoute('/_private/companies/_template/$id/marketing-campaigns')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getCompanyQueryOptions(opts.params.id)),
  staticData: {
    pageTitle: 'Marketing Campaigns',
    isFullWidth: true,
    isViewOnly: true,
    tabKey: 'client/marketing-campaigns',
  },
  pendingComponent: Loading,
});
